package com.evoapps.evoshift.ui.notifications

import com.evoapps.evoshift.widgets.IconButtonWithTooltip
import com.evoapps.evoshift.ui.util.dayAndDateInSentence
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import com.evoapps.evoshift.ui.theme.animateItemIfMotion
import com.evoapps.evoshift.domain.util.AppClock
import evoshift.composeapp.generated.resources.notif_break_reminder_body
import evoshift.composeapp.generated.resources.notif_break_reminder_title
import evoshift.composeapp.generated.resources.notif_new_applicant_title
import evoshift.composeapp.generated.resources.notif_borrowed_title
import androidx.compose.material.icons.filled.FreeBreakfast
import androidx.compose.material.icons.filled.HealthAndSafety
import androidx.compose.material.icons.filled.School
import com.evoapps.evoshift.ui.adaptive.LocalWindowWidthClass
import com.evoapps.evoshift.widgets.EvoTopBar
import com.evoapps.evoshift.widgets.TopBarAction
import com.evoapps.evoshift.widgets.helpAction
import com.evoapps.evoshift.ui.notifications.notificationsAction
import com.evoapps.evoshift.ui.util.HelpCentreButton
import com.evoapps.evoshift.ui.util.HelpPage
import com.evoapps.evoshift.domain.model.RosterIds
import com.evoapps.evoshift.domain.model.User
import com.evoapps.evoshift.domain.model.capabilitiesAnywhere
import com.evoapps.evoshift.domain.model.capabilitiesAt
import com.evoapps.evoshift.viewmodels.Gate
import com.evoapps.evoshift.viewmodels.shows
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.lazy.grid.GridItemSpan
import androidx.compose.foundation.lazy.grid.items
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.automirrored.filled.ArrowBack
import androidx.compose.material.icons.filled.CalendarMonth
import androidx.compose.material.icons.filled.Campaign
import androidx.compose.material.icons.filled.EditNote
import androidx.compose.material.icons.filled.Cancel
import androidx.compose.material.icons.filled.CheckCircle
import androidx.compose.material.icons.filled.DoneAll
import androidx.compose.material.icons.filled.EventAvailable
import androidx.compose.material.icons.filled.EventBusy
import androidx.compose.material.icons.filled.Notifications
import androidx.compose.material.icons.filled.PersonOff
import androidx.compose.material.icons.filled.PersonSearch
import androidx.compose.material.icons.filled.Checklist
import androidx.compose.material.icons.filled.SwapHoriz
import androidx.compose.material.icons.filled.Work
import androidx.compose.material3.Badge
import androidx.compose.material3.BadgedBox
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Scaffold
import androidx.compose.material3.Text
import androidx.compose.material3.TopAppBar
import androidx.compose.material3.TopAppBarDefaults
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.remember
import androidx.compose.runtime.staticCompositionLocalOf
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import com.evoapps.evoshift.Route
import com.evoapps.evoshift.domain.model.Notification
import com.evoapps.evoshift.domain.model.NotificationData
import com.evoapps.evoshift.domain.model.NotificationType
import com.evoapps.evoshift.ui.Cream
import com.evoapps.evoshift.ui.DarkGold
import com.evoapps.evoshift.ui.DeepNavy
import com.evoapps.evoshift.ui.adaptive.AdaptiveCardGrid
import com.evoapps.evoshift.ui.adaptive.DetailPane
import com.evoapps.evoshift.ui.adaptive.ListDetailLayout
import com.evoapps.evoshift.ui.adaptive.PanePlaceholder
import com.evoapps.evoshift.ui.adaptive.handCursor
import com.evoapps.evoshift.ui.adaptive.showsDetailPane
import androidx.compose.foundation.border
import androidx.compose.material3.Button
import androidx.compose.material3.ButtonDefaults
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
import androidx.compose.runtime.saveable.rememberSaveable
import evoshift.composeapp.generated.resources.wide_pick_notification
import evoshift.composeapp.generated.resources.notification_open
import com.evoapps.evoshift.ui.adaptive.cardClickable
import com.evoapps.evoshift.ui.util.dayAndDate
import com.evoapps.evoshift.ui.util.monthName
import com.evoapps.evoshift.viewmodels.NotificationsViewModel
import evoshift.composeapp.generated.resources.Res
import evoshift.composeapp.generated.resources.notification_takeover_title
import evoshift.composeapp.generated.resources.back
import evoshift.composeapp.generated.resources.dashboard_notifications
import evoshift.composeapp.generated.resources.notif_announcement_title
import evoshift.composeapp.generated.resources.notif_announcement_title_plain
import evoshift.composeapp.generated.resources.notif_shift_note_title
import evoshift.composeapp.generated.resources.notif_absence_title
import evoshift.composeapp.generated.resources.notif_on_behalf_title
import evoshift.composeapp.generated.resources.notif_availability_title
import evoshift.composeapp.generated.resources.notif_claim_approved_title
import evoshift.composeapp.generated.resources.notif_claim_pending_title
import evoshift.composeapp.generated.resources.notif_claim_rejected_title
import evoshift.composeapp.generated.resources.notif_direct_title
import evoshift.composeapp.generated.resources.notif_due
import evoshift.composeapp.generated.resources.notif_marketplace_title
import evoshift.composeapp.generated.resources.notif_month_line
import evoshift.composeapp.generated.resources.notif_note
import evoshift.composeapp.generated.resources.notif_now_public_title
import evoshift.composeapp.generated.resources.notif_no_show_title
import evoshift.composeapp.generated.resources.notif_checklist_overdue_title
import evoshift.composeapp.generated.resources.notif_checklist_reminder_title
import evoshift.composeapp.generated.resources.notif_open_shifts_title
import evoshift.composeapp.generated.resources.notif_open_shifts_count
import evoshift.composeapp.generated.resources.notif_review_title
import evoshift.composeapp.generated.resources.notif_roster_published_title
import evoshift.composeapp.generated.resources.notif_roster_updated_title
import evoshift.composeapp.generated.resources.notif_roster_shifts_count
import evoshift.composeapp.generated.resources.notif_shift_line
import evoshift.composeapp.generated.resources.notif_taken_by_title
import evoshift.composeapp.generated.resources.notifications_earlier
import evoshift.composeapp.generated.resources.notifications_empty
import evoshift.composeapp.generated.resources.notifications_mark_all
import evoshift.composeapp.generated.resources.notifications_new
import kotlinx.datetime.LocalDate
import kotlinx.datetime.TimeZone
import kotlinx.datetime.toLocalDateTime
import org.jetbrains.compose.resources.stringResource
import evoshift.composeapp.generated.resources.capacity_days
import evoshift.composeapp.generated.resources.notif_availability_reminder_title
import evoshift.composeapp.generated.resources.notif_course_assigned_title
import evoshift.composeapp.generated.resources.notif_ohs_confirmation_body
import evoshift.composeapp.generated.resources.notif_ohs_confirmation_title
import org.kodein.di.compose.rememberInstance
import kotlin.time.Instant

/** Opens the notifications screen; provided by the app shell so every screen's bell can use it. */
val LocalOpenNotifications = staticCompositionLocalOf<() -> Unit> { {} }

/** The bell in the top bars: unread count badge, opens the notifications screen. */
@Composable
fun NotificationsBell() {
    val viewModel: NotificationsViewModel by rememberInstance()
    val state by viewModel.uiState.collectAsStateWithLifecycle()
    val open = LocalOpenNotifications.current
    IconButtonWithTooltip(onClick = open, tooltip = stringResource(Res.string.dashboard_notifications)) {
        BadgedBox(badge = {
            if (state.unreadCount > 0) {
                Badge(containerColor = DarkGold, contentColor = DeepNavy) {
                    Text(if (state.unreadCount > 9) "9+" else state.unreadCount.toString())
                }
            }
        }) {
            Icon(Icons.Default.Notifications, stringResource(Res.string.dashboard_notifications))
        }
    }
}

/** The bell as an action of the shared top bar (SH-89): never folded into ⋮, with its badge. */
@Composable
fun notificationsAction(): com.evoapps.evoshift.widgets.TopBarAction {
    val viewModel: NotificationsViewModel by rememberInstance()
    val state by viewModel.uiState.collectAsStateWithLifecycle()
    return com.evoapps.evoshift.widgets.TopBarAction(
        label = stringResource(Res.string.dashboard_notifications),
        icon = Icons.Default.Notifications,
        onClick = LocalOpenNotifications.current,
        collapsible = false,
        badge = state.unreadCount
    )
}

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun NotificationsScreen(
    viewModel: NotificationsViewModel,
    onNavigateBack: () -> Unit,
    onOpen: (Route) -> Unit
) {
    val state by viewModel.uiState.collectAsStateWithLifecycle()
    // A month opens in the roster builder for those who build that workplace's rosters, else the schedule.
    val user = state.user
    fun buildsRostersFor(n: Notification): Boolean = n.buildsRostersFor(user)
    val (fresh, earlier) = state.items.partition { !it.isRead }
    // SH-105: wide windows read the chosen notification beside the list; "Open" goes on from it.
    val paneMode = LocalWindowWidthClass.current.showsDetailPane
    var selectedKey by rememberSaveable { mutableStateOf<String?>(null) }
    fun keyOf(n: Notification) = n.id + n.createdAt
    val selected = selectedKey?.let { key -> state.items.firstOrNull { keyOf(it) == key } }
    fun choose(n: Notification) {
        if (!n.isRead) viewModel.markRead(n)
        if (paneMode) selectedKey = keyOf(n) else n.destination(buildsRostersFor(n))?.let(onOpen)
    }

    Scaffold(
        containerColor = Cream,
        topBar = {
            EvoTopBar(
                title = stringResource(Res.string.dashboard_notifications),
                onBack = onNavigateBack,
                actions = buildList {
                    add(helpAction(HelpPage.NOTIFICATIONS))
                    if (fresh.isNotEmpty()) {
                        add(TopBarAction(stringResource(Res.string.notifications_mark_all), Icons.Default.DoneAll, { viewModel.markAllRead() }, collapsible = false))
                    }
                }
            )
        }
    ) { padding ->
        if (state.items.isEmpty() && !state.isLoading) {
            Box(Modifier.fillMaxSize().padding(padding), contentAlignment = Alignment.Center) {
                Text(stringResource(Res.string.notifications_empty), color = DeepNavy.copy(alpha = 0.6f))
            }
            return@Scaffold
        }
        // A feed reads top to bottom, so wide windows get at most two columns (not three): wide
        // enough to use the space, few enough that the order stays easy to follow.
        ListDetailLayout(
            selected = selected != null,
            onClose = { selectedKey = null },
            modifier = Modifier.padding(padding),
            maxWidth = LocalWindowWidthClass.current.wideContentMaxWidth,
            placeholder = { PanePlaceholder(stringResource(Res.string.wide_pick_notification), Icons.Default.Notifications) },
            detail = {
                selected?.let { n ->
                    NotificationDetailPane(
                        notification = n,
                        onClose = { selectedKey = null },
                        onOpen = n.destination(buildsRostersFor(n))?.let { route -> { onOpen(route) } }
                    )
                }
            },
            list = {
        AdaptiveCardGrid(
            modifier = Modifier.fillMaxSize(),
            minItemWidth = NotificationMinWidth,
            spacing = 8.dp,
            maxWidth = LocalWindowWidthClass.current.wideContentMaxWidth
        ) {
            if (fresh.isNotEmpty()) {
                item(span = { GridItemSpan(maxLineSpan) }) { SectionTitle(stringResource(Res.string.notifications_new)) }
                // SH-158: one key in both sections (they never share a notification), so one read
                // glides from New down to Earlier.
                items(fresh, key = { "n-" + it.id + it.createdAt }) { n ->
                    Box(Modifier.animateItemIfMotion(this), propagateMinConstraints = true) {
                        NotificationRow(n, selected = paneMode && keyOf(n) == selectedKey) { choose(n) }
                    }
                }
            }
            if (earlier.isNotEmpty()) {
                item(span = { GridItemSpan(maxLineSpan) }) { SectionTitle(stringResource(Res.string.notifications_earlier)) }
                items(earlier, key = { "n-" + it.id + it.createdAt }) { n ->
                    Box(Modifier.animateItemIfMotion(this), propagateMinConstraints = true) {
                        NotificationRow(n, selected = paneMode && keyOf(n) == selectedKey) { choose(n) }
                    }
                }
            }
        }
            }
        )
    }
}

/** Wide enough that a 1100dp window fits two notification columns, not three. */
private val NotificationMinWidth = 420.dp

@Composable
private fun SectionTitle(text: String) {
    Text(
        text,
        style = MaterialTheme.typography.titleSmall,
        fontWeight = FontWeight.Bold,
        color = DeepNavy.copy(alpha = 0.7f),
        modifier = Modifier.padding(top = 8.dp, bottom = 4.dp)
    )
}

/**
 * SH-105: the chosen notification beside the list on wide windows: all of it, and [onOpen] to go
 * where it points (null: nowhere to go).
 */
@Composable
private fun NotificationDetailPane(notification: Notification, onClose: () -> Unit, onOpen: (() -> Unit)?) {
    DetailPane(
        title = notificationTitle(notification),
        subtitle = timeLabel(notification.createdAt),
        icon = notification.icon(),
        onClose = onClose,
        dark = false,
        modifier = Modifier.fillMaxSize()
    ) {
        notificationBody(notification)?.let {
            Text(it, style = MaterialTheme.typography.bodyLarge, color = DeepNavy)
        }
        if (onOpen != null) {
            Button(
                onClick = onOpen,
                colors = ButtonDefaults.buttonColors(containerColor = DeepNavy, contentColor = Color.White),
                modifier = Modifier.handCursor()
            ) {
                Text(stringResource(Res.string.notification_open))
            }
        }
    }
}

@Composable
private fun NotificationRow(notification: Notification, selected: Boolean = false, onClick: () -> Unit) {
    val unread = !notification.isRead
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .background(if (unread) Color.White else Color.White.copy(alpha = 0.6f), RoundedCornerShape(12.dp))
            .then(if (selected) Modifier.border(2.dp, DarkGold, RoundedCornerShape(12.dp)) else Modifier)
            .cardClickable(RoundedCornerShape(12.dp), onClick = onClick)
            .padding(14.dp),
        verticalAlignment = Alignment.Top
    ) {
        Box(
            modifier = Modifier.size(36.dp).clip(CircleShape).background(if (unread) DeepNavy else DeepNavy.copy(alpha = 0.15f)),
            contentAlignment = Alignment.Center
        ) {
            Icon(notification.icon(), contentDescription = null, tint = if (unread) DarkGold else DeepNavy, modifier = Modifier.size(20.dp))
        }
        Spacer(Modifier.width(12.dp))
        Column(Modifier.weight(1f), verticalArrangement = Arrangement.spacedBy(2.dp)) {
            Text(
                notificationTitle(notification),
                style = MaterialTheme.typography.bodyLarge,
                fontWeight = if (unread) FontWeight.Bold else FontWeight.Medium,
                color = DeepNavy
            )
            notificationBody(notification)?.let {
                Text(it, style = MaterialTheme.typography.bodyMedium, color = DeepNavy.copy(alpha = 0.75f))
            }
            Text(timeLabel(notification.createdAt), style = MaterialTheme.typography.labelSmall, color = DeepNavy.copy(alpha = 0.5f))
        }
        if (unread) {
            Box(Modifier.padding(top = 6.dp).size(8.dp).clip(CircleShape).background(DarkGold))
        }
    }
}

private fun Notification.kind(): String? = data[NotificationData.KIND]

private fun Notification.icon(): ImageVector = when (type) {
    NotificationType.ROSTER_PUBLISHED, NotificationType.SHIFT_ASSIGNED -> Icons.Default.CalendarMonth
    NotificationType.OPEN_SHIFTS_AVAILABLE -> Icons.Default.Work
    NotificationType.SHIFT_SWAP_REQUEST, NotificationType.SHIFT_CLAIM_PENDING -> Icons.Default.SwapHoriz
    NotificationType.SHIFT_CLAIM_APPROVED, NotificationType.SHIFT_SWAP_APPROVED -> Icons.Default.CheckCircle
    NotificationType.SHIFT_CLAIM_REJECTED, NotificationType.SHIFT_SWAP_REJECTED -> Icons.Default.Cancel
    NotificationType.AVAILABILITY_REQUEST -> Icons.Default.EventAvailable
    NotificationType.SHIFT_NO_SHOW -> Icons.Default.PersonOff
    NotificationType.CHECKLIST_OVERDUE -> Icons.Default.Checklist
    NotificationType.GENERAL -> when (kind()) {
        NotificationData.Kind.ABSENCE_REQUEST, NotificationData.Kind.REQUEST_ON_BEHALF -> Icons.Default.EventBusy
        NotificationData.Kind.ANNOUNCEMENT -> Icons.Default.Campaign
        NotificationData.Kind.SHIFT_NOTE -> Icons.Default.EditNote
        NotificationData.Kind.BREAK_REMINDER -> Icons.Default.FreeBreakfast
        NotificationData.Kind.COURSE_ASSIGNED -> Icons.Default.School
        NotificationData.Kind.OHS_CONFIRMATION -> Icons.Default.HealthAndSafety
        NotificationData.Kind.NEW_APPLICANT -> Icons.Default.PersonSearch
        else -> Icons.Default.Notifications
    }
}

/** Whether [user] builds the rosters [this] is about (a month then opens in the roster builder). */
internal fun Notification.buildsRostersFor(user: User?): Boolean =
    data[NotificationData.ROSTER_ID]?.let { rosterId -> user?.capabilitiesAt(RosterIds.workplaceIdOf(rosterId))?.shows(Gate.ROSTERS) }
        ?: (user?.capabilitiesAnywhere?.shows(Gate.TEAM_REQUESTS) == true)

/** [destination] for [user]: what tapping it in the list opens (also a Mac notification's click, SH-141). */
fun Notification.destinationFor(user: User?): Route? = destination(buildsRostersFor(user))

/** Where tapping a notification leads; null when there is nothing specific to open. */
fun Notification.destination(isManager: Boolean): Route? = when (type) {
    NotificationType.ROSTER_PUBLISHED, NotificationType.SHIFT_ASSIGNED ->
        data[NotificationData.ROSTER_ID]?.takeIf { isManager }?.let { Route.RosterDetail(it) } ?: Route.Schedule()
    NotificationType.OPEN_SHIFTS_AVAILABLE -> Route.Schedule(showMarketplace = true)
    NotificationType.SHIFT_SWAP_REQUEST ->
        if (kind() == NotificationData.Kind.REVIEW) Route.Requests else Route.Schedule(showMarketplace = true)
    NotificationType.SHIFT_CLAIM_PENDING -> Route.Requests
    NotificationType.SHIFT_CLAIM_APPROVED, NotificationType.SHIFT_CLAIM_REJECTED,
    NotificationType.SHIFT_SWAP_APPROVED, NotificationType.SHIFT_SWAP_REJECTED -> Route.Schedule()
    NotificationType.AVAILABILITY_REQUEST -> Route.Availability
    // The month in the roster builder, where the shift can be reassigned.
    NotificationType.SHIFT_NO_SHOW ->
        data[NotificationData.ROSTER_ID]?.takeIf { isManager }?.let { Route.RosterDetail(it) } ?: Route.Schedule()
    // SH-121: the person ticks the checklist; managers see the day's checklists.
    NotificationType.CHECKLIST_OVERDUE ->
        if (kind() == NotificationData.Kind.CHECKLIST_REMINDER) data[NotificationData.SHIFT_ID]?.let { Route.ShiftChecklist(it) }
        else Route.Checklists(workplaceId = data[NotificationData.WORKPLACE_ID], date = data[NotificationData.DATE])
    NotificationType.GENERAL -> when (kind()) {
        NotificationData.Kind.ABSENCE_REQUEST -> Route.Requests
        // SH-223: a request filed on the person's behalf: their own list.
        NotificationData.Kind.REQUEST_ON_BEHALF -> Route.Absences
        NotificationData.Kind.NOW_PUBLIC -> Route.Schedule()
        NotificationData.Kind.ANNOUNCEMENT -> Route.Announcements
        NotificationData.Kind.SHIFT_NOTE -> Route.Schedule()
        // SH-126: the course to take; the OHS record to confirm.
        NotificationData.Kind.COURSE_ASSIGNED -> data[NotificationData.WORKPLACE_ID]?.let { wp ->
            data[NotificationData.COURSE_ID]?.let { Route.TakeCourse(wp, it) } ?: Route.Courses(wp)
        }
        NotificationData.Kind.OHS_CONFIRMATION -> data[NotificationData.WORKPLACE_ID]?.let { Route.OhsTraining(it) }
        // SH-125: the post's applicants (managers only receive these).
        // SH-210: recruiters who are not managers are told too (the screen checks who reads the post).
        NotificationData.Kind.NEW_APPLICANT -> data[NotificationData.JOB_POST_ID]?.let { Route.Applicants(it) }
        else -> null
    }
}

/** The title in the reader's language; notifications without the needed facts keep their stored text. */
@Composable
internal fun notificationTitle(n: Notification): String {
    val name = n.data[NotificationData.NAME]?.takeIf { it.isNotBlank() }
    return when (n.type) {
        NotificationType.ROSTER_PUBLISHED ->
            // SH-271: a republish, to the people whose shifts changed.
            if (n.kind() == NotificationData.Kind.ROSTER_UPDATED) stringResource(Res.string.notif_roster_updated_title)
            else stringResource(Res.string.notif_roster_published_title)
        // SH-236: a colleague's shift was split and the second part is yours.
        NotificationType.SHIFT_ASSIGNED ->
            if (n.kind() == NotificationData.Kind.TAKEOVER) name?.let { stringResource(Res.string.notification_takeover_title, it) } else null
        NotificationType.OPEN_SHIFTS_AVAILABLE -> stringResource(Res.string.notif_open_shifts_title)
        NotificationType.SHIFT_SWAP_REQUEST -> when (n.kind()) {
            NotificationData.Kind.MARKETPLACE -> stringResource(Res.string.notif_marketplace_title)
            NotificationData.Kind.DIRECT -> name?.let { stringResource(Res.string.notif_direct_title, it) }
            NotificationData.Kind.REVIEW -> name?.let { stringResource(Res.string.notif_review_title, it) }
            else -> null
        }
        NotificationType.SHIFT_CLAIM_PENDING -> name?.let { stringResource(Res.string.notif_claim_pending_title, it) }
        NotificationType.SHIFT_CLAIM_APPROVED ->
            if (name != null) stringResource(Res.string.notif_taken_by_title, name)
            else stringResource(Res.string.notif_claim_approved_title)
        NotificationType.SHIFT_CLAIM_REJECTED -> stringResource(Res.string.notif_claim_rejected_title)
        NotificationType.AVAILABILITY_REQUEST ->
            if (n.kind() == NotificationData.Kind.AVAILABILITY_REMINDER) stringResource(Res.string.notif_availability_reminder_title)
            else stringResource(Res.string.notif_availability_title)
        NotificationType.SHIFT_NO_SHOW -> name?.let { stringResource(Res.string.notif_no_show_title, it) }
        NotificationType.CHECKLIST_OVERDUE ->
            if (n.kind() == NotificationData.Kind.CHECKLIST_REMINDER) stringResource(Res.string.notif_checklist_reminder_title)
            else name?.let { stringResource(Res.string.notif_checklist_overdue_title, it) }
        NotificationType.GENERAL -> when (n.kind()) {
            NotificationData.Kind.NOW_PUBLIC -> stringResource(Res.string.notif_now_public_title)
            NotificationData.Kind.ABSENCE_REQUEST -> name?.let { stringResource(Res.string.notif_absence_title, it) }
            NotificationData.Kind.REQUEST_ON_BEHALF -> name?.takeIf { it.isNotBlank() }?.let { stringResource(Res.string.notif_on_behalf_title, it) }
            // SH-118: a manager's post (the text is the message), a note on one's shift.
            NotificationData.Kind.ANNOUNCEMENT ->
                if (name != null) stringResource(Res.string.notif_announcement_title, name)
                else stringResource(Res.string.notif_announcement_title_plain)
            NotificationData.Kind.SHIFT_NOTE -> stringResource(Res.string.notif_shift_note_title)
            NotificationData.Kind.BREAK_REMINDER -> stringResource(Res.string.notif_break_reminder_title)
            NotificationData.Kind.COURSE_ASSIGNED -> stringResource(Res.string.notif_course_assigned_title)
            NotificationData.Kind.OHS_CONFIRMATION -> stringResource(Res.string.notif_ohs_confirmation_title)
            NotificationData.Kind.NEW_APPLICANT -> stringResource(Res.string.notif_new_applicant_title)
            // SH-267: someone of the team planned at another workplace of the group.
            NotificationData.Kind.BORROWED -> name?.let { stringResource(Res.string.notif_borrowed_title, it) }
            else -> null
        }
        else -> null
    } ?: n.title
}

@Composable
internal fun notificationBody(n: Notification): String? {
    val date = n.data[NotificationData.DATE]?.let { runCatching { LocalDate.parse(it) }.getOrNull() }
    val start = n.data[NotificationData.START]
    val end = n.data[NotificationData.END]
    val month = n.data[NotificationData.MONTH]?.toIntOrNull()
    val year = n.data[NotificationData.YEAR]
    val workplace = n.data[NotificationData.WORKPLACE_NAME]
    val count = n.data[NotificationData.COUNT]?.toIntOrNull()
    val note = n.data[NotificationData.NOTE]?.takeIf { it.isNotBlank() }

    val lines = buildList {
        // SH-116: how long without a break, then the shift.
        if (n.kind() == NotificationData.Kind.BREAK_REMINDER && count != null) add(stringResource(Res.string.notif_break_reminder_body, count))
        // SH-126: which course and by when (no shift times, so nothing below adds to it); an OHS
        // instruction to confirm.
        if (n.kind() == NotificationData.Kind.COURSE_ASSIGNED) {
            n.data[NotificationData.COURSE]?.takeIf { it.isNotBlank() }?.let { add(it) }
            if (date != null) add(stringResource(Res.string.notif_due, dayAndDateInSentence(date)))
        }
        if (n.kind() == NotificationData.Kind.OHS_CONFIRMATION) add(stringResource(Res.string.notif_ohs_confirmation_body))
        when {
            // A month-wide notification: "Luty 2026 · Kawiarnia Aurora Gdańsk" and how many shifts.
            month != null && year != null -> {
                add(listOfNotNull(stringResource(Res.string.notif_month_line, monthName(month), year), workplace).joinToString(" · "))
                if (count != null) add(
                    stringResource(
                        if (n.type == NotificationType.OPEN_SHIFTS_AVAILABLE) Res.string.notif_open_shifts_count else Res.string.notif_roster_shifts_count,
                        count
                    )
                )
                // SH-48: a request for part of the month says which days.
                val firstDay = start?.let { runCatching { LocalDate.parse(it) }.getOrNull() }
                val lastDay = end?.let { runCatching { LocalDate.parse(it) }.getOrNull() }
                if (n.type == NotificationType.AVAILABILITY_REQUEST && firstDay != null && lastDay != null) {
                    add(stringResource(Res.string.capacity_days, firstDay.day, lastDay.day))
                }
                if (n.type == NotificationType.AVAILABILITY_REQUEST && date != null) add(stringResource(Res.string.notif_due, dayAndDateInSentence(date)))
            }
            // An absence: from - to.
            date != null && n.kind() == NotificationData.Kind.ABSENCE_REQUEST -> {
                val until = end?.let { runCatching { LocalDate.parse(it) }.getOrNull() }
                add(if (until != null && until != date) "${dayAndDate(date)} – ${dayAndDateInSentence(until)}" else dayAndDate(date))
            }
            // A shift: "wtorek, 3 lutego, 06:00–14:00" (SH-121: under the checklist's name).
            date != null && start != null && end != null -> {
                n.data[NotificationData.CHECKLIST]?.takeIf { it.isNotBlank() }?.let { add(it) }
                add(stringResource(Res.string.notif_shift_line, dayAndDate(date), start, end))
            }
        }
        if (note != null) add(stringResource(Res.string.notif_note, note))
    }
    // Without facts (older notifications) the stored message is all there is.
    return lines.joinToString("\n").ifEmpty { n.message.ifBlank { null } }
}

@Composable
private fun timeLabel(createdAt: String): String {
    val zone = TimeZone.currentSystemDefault()
    val at = remember(createdAt) { runCatching { Instant.parse(createdAt).toLocalDateTime(zone) }.getOrNull() } ?: return ""
    val today = remember { AppClock.now().toLocalDateTime(zone).date }
    val time = "${at.hour.toString().padStart(2, '0')}:${at.minute.toString().padStart(2, '0')}"
    return if (at.date == today) time else "${dayAndDate(at.date)}, $time"
}
